module.exports = __webpack_public_path__ + "img/LOGO 2_1@2x.ce9d7eb1.png";